import theme from "@/theme";

export const stylesContact = {
  pageBackground: {
    width: "100%",
    minHeight: "90vh",
    bgcolor: theme.palette.custom.mainWhite,
    display: "flex",
    justifyContent: "center",
    padding: "1rem 2rem",
  },
  wrapper: {
    width: "100%",
    bgcolor: theme.palette.custom.mainWhite,
    display: "flex",
    flexDirection: "column",
    gap: "0.5rem",
  },
  title: {
    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: "1.5rem",
    color: theme.palette.custom.blueGray900,
    textAlign: "center",
    marginBottom: "1.5rem",
  },
  fieldLabel: {
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "14px",
    color: theme.palette.custom.blueGray700,
  },
  inputField: {
    width: "100%",
    borderRadius: "28px",
    backgroundColor: theme.palette.custom.mainWhite,
    "& .MuiOutlinedInput-root": {
      borderRadius: "28px",
      backgroundColor: theme.palette.custom.mainWhite,
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "#E0E0E9",
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: "#E0E0E9",
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: "#E0E0E9",
      },
    },
    "& input": {
      fontFamily: "Inter",
      fontWeight: 500,
      fontSize: "16px",
      lineHeight: "150%",
      color: "#383C40",
      caretColor: "#5B87F8",
      "::placeholder": {
        color: "#C6CACE",
      },
    },
    "& textarea": {
      fontFamily: "Inter",
      fontWeight: 500,
      fontSize: "16px",
      lineHeight: "150%",
      minHeight: "200px",
      maxHeight: "35vh",
      color: "#383C40",
      caretColor: "#5B87F8",
      "::placeholder": {
        color: "#C6CACE",
      },
    },
    marginBottom: "0.5rem",
  },
  submitButton: {
    width: "100%",
    height: "54px",
    borderRadius: "28px",
    backgroundColor: theme.palette.custom.mainBlue,
    color: "#FFFFFF",
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "16px",
    textTransform: "none",
    marginTop: "30px",
    "&:hover": {
      backgroundColor: "#2874d8",
    },
    "&.Mui-disabled": {
      backgroundColor: theme.palette.custom.mainBlueDisable,
      color: "#FFFFFF",
    },
  },
};
